module.exports = __webpack_public_path__ + "static/media/sim-card.e197cbe2.svg";